export const claimEndpoints = (builder) => ({
  getClaimsByPolicy: builder.query({
    query: ({ policyId, insuranceType }) => ({
      url: `/GeneralInsurance/get-claims-by-policy/${policyId}/${insuranceType}`,
      method: 'GET',
    }),
    providesTags: (result, error, { policyId }) => [{ type: 'Claim', id: policyId }, 'Claim'],
  }),

  getClaimById: builder.query({
    query: (id) => ({
      url: `/GeneralInsurance/get-claim/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'Claim', id }],
  }),

  saveClaim: builder.mutation({
    query: (data) => ({
      url: '/GeneralInsurance/save-claim',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: (result, error, arg) => [
      { type: 'Claim', id: arg.policyId },
      'Claim'
    ],
  }),

  deleteClaim: builder.mutation({
    query: (id) => ({
      url: `/GeneralInsurance/delete-claim/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['Claim'],
  }),
});
